export class GenApplicationPersonEntity{
    id:number;
    applicationId:number;
    personId:number;

    constructor(){}
}